import React, { Component } from 'react'
import { connect } from "react-redux";
import { SetDepositDateSelect, SetDepositTimeSelect } from '$Deposits/store/actions/DepositAction'
import moment from 'moment'



export class DatePicker extends Component {


    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        this.initializeDateTime()
    }

    initializeDateTime = () => {
        const { methods } = this.props.MethodsActive

        this.props.SetDepositDateSelect(moment(new Date()).format('YYYY-MM-DD'))

        if(methods === 'LB'){
            // CXPC-1695: 如果沒有提供時間，無法送出””提交””
            this.props.SetDepositTimeSelect('NOT_SET')
        }else{
            // 默認給當前時間
            const currentTime = moment().format('HH:mm')
            this.props.SetDepositTimeSelect(currentTime)
        }
    }


    render() {

        const {
            mode = 'date',
            minDate = moment(new Date('1940-01-01')),
            maxDate = moment(new Date()),
            DepositDateSelect,
            DepositTimeSelect,
            SetDepositDateSelect,
            SetDepositTimeSelect,
            DatePicker,
        } = this.props

        return (
            <>
                <DatePicker
                    maxDate={maxDate}
                    minDate={minDate}
                    defaults={mode == 'date' ? DepositDateSelect : DepositTimeSelect}
                    onChange={(v) => {
                        if (mode == 'date') {
                            SetDepositDateSelect(v)
                        } else if (mode == 'time') {
                            SetDepositTimeSelect(v)
                        }
                    }}
                />
            </>

        )
    }


}

const mapStateToProps = state => ({
    DepositDateSelect: state.DepositDateSelect,
    DepositTimeSelect: state.DepositTimeSelect,
    MethodsActive: state.MethodsActive,
});
const mapDispatchToProps = {
    SetDepositDateSelect: (data) => SetDepositDateSelect(data),
    SetDepositTimeSelect: (data) => SetDepositTimeSelect(data),

};
export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);
